import { toast } from "@birdwatch/ui/toast";

import {
  type PaymentDefaultActionScope,
  PaymentDefaultScope,
} from "../_types/payment-default-scope";

const DEFAULT_SCOPE_DESCRIPTION: Record<PaymentDefaultActionScope, string> = {
  [PaymentDefaultScope.Account]: "Order & Membership payments",
  [PaymentDefaultScope.Order]: "Order payments",
  [PaymentDefaultScope.Membership]: "Membership payments",
};

/** Shows a success toast when the default payment method is updated. */
export const defaultUpdated = (
  brand: string,
  last4: string,
  scope: PaymentDefaultActionScope = PaymentDefaultScope.Account,
) => {
  toast.success({
    title: "Default payment method updated",
    description: `${brand} •••• ${last4} is now set as default payment method for ${DEFAULT_SCOPE_DESCRIPTION[scope]}.`,
  });
};

/** Shows an error toast when setting the default payment method fails. */
export const defaultFailed = () => {
  toast.error({
    title: "Failed to update default",
    description: "Something went wrong. Please try again.",
  });
};

/** Shows a success toast when a payment method is removed. */
export const removed = (brand: string, last4: string) => {
  toast.success({
    title: "Payment method removed",
    description: `${brand} •••• ${last4} has been removed.`,
  });
};

/** Shows an error toast when removal is blocked because it's the only payment method. */
export const cannotRemove = () => {
  toast.error({
    title: "Cannot remove payment method",
    description:
      "You need at least one payment method. Add a new payment method first, then you can remove this one.",
  });
};

/** Shows an error toast when payment method removal fails. */
export const removeFailed = () => {
  toast.error({
    title: "Can't remove payment method",
    description: "Something went wrong. Please try again.",
  });
};

/** Shows a success toast when a payment method is updated. */
export const updated = (brand: string, last4: string) => {
  toast.success({
    title: "Payment method updated",
    description: `Changes to ${brand} •••• ${last4} have been saved.`,
  });
};

/** Shows an error toast when the old payment method couldn't be removed after adding a new one. */
export const oldRemoveFailed = () => {
  toast.error({
    title: "Couldn't remove old payment method",
    description:
      "Your new card was added but the old one couldn't be removed. You can remove it manually.",
  });
};
